export default function filterBy(array, filterValue, fields) {
  return array.filter(o =>
    fields.some(field =>
      o[field].toLowerCase().includes(filterValue.toLowerCase()),
    ),
  );
}
